import React from 'react'

export default function ReflexiveModalFr() {
  return (
    <div className='column-table-reflexive'>
        <p className='bold'>Reflexive</p>
        <p>me</p>
        <p>te</p>
        <p>se</p>
        <p>nous</p>
        <p>vous</p>
        <p>se</p>
    </div>
  )
}
